import { Preview } from "../../../../types/IAction";
import * as actions from "../../../actions/comisionManual";
import { GetComisionesManualExtras } from "../../../reducers/comisionManual";

export interface ComisionesManualesAdminDispatcher {
  clearComisionesManualExtras: () => Promise<Preview<void>>;
  getComisionesManualExtras: (
    fechaPago: string
  ) => Promise<Preview<GetComisionesManualExtras>>;
  deleteComisionManual: (
    id: number,
    callback?: () => void
  ) => Promise<Preview<any>>;
}

export const comisionesManualesAdminDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ComisionesManualesAdminDispatcher = dispatch => ({
  clearComisionesManualExtras: () => {
    return dispatch(actions.clearComisionesManualExtras());
  },
  getComisionesManualExtras: (fechaPago: string) => {
    return dispatch(actions.getComisionesManualExtras(fechaPago));
  },
  deleteComisionManual: (id: number, callback?: () => void) => {
    return dispatch(actions.deleteComisionManual(id, callback));
  }
});
